import { IDoFilter } from '@app/main/main-content/display-options/interfaces/do-filter.interface';
import { DoFilterKey } from '@app/main/main-content/display-options/enums/do-filter-key.enum';
import { DoFilterOptionKey } from '@app/main/main-content/display-options/enums/do-filter-option-key.enum';
import { IDoFilterSelectionSummary } from '@app/main/main-content/display-options/interfaces/do-filter.interface';
import { IUiStateDoFilters } from '@app/main/main-content/display-options/interfaces/ui-state-do-filters.interface';
import { DoFilterSelectionMode } from '@app/main/main-content/display-options/enums/do-filter-selection-mode.enum';

export function getFilterSelectionSummary(filter: IDoFilter): IDoFilterSelectionSummary {
  const selected = filter.selected;
  const total = filter.options;
  const selectedCount = selected.length;
  const totalCount = total.length;

  if (selectedCount === 0) {
    return { selectedCount, totalCount, mode: DoFilterSelectionMode.None };
  }

  if (selectedCount === 1) {
    return { selectedCount, totalCount, mode: DoFilterSelectionMode.Single, singleLabel: selected[0].label };
  }

  if (selectedCount === totalCount) {
    return { selectedCount, totalCount, mode: DoFilterSelectionMode.All };
  }

  return { selectedCount, totalCount, mode: DoFilterSelectionMode.Partial };
}

function getSectionRows(filter: IDoFilter) {
  return filter.sections?.flat().flatMap(item => [item, ...(item.children ?? [])]) ?? [];
}

export function syncSelectedFromSections(filter: IDoFilter): void {
  const checkedKeys = new Set(
    getSectionRows(filter)
      .filter(row => row.checked)
      .map(row => row.key)
  );

  filter.selected = filter.options.filter(option => checkedKeys.has(option.key));
}

export function setAllSectionRowsChecked(filter: IDoFilter, checked: boolean): void {
  getSectionRows(filter).forEach(row => (row.checked = checked));
}

export function applyUiStateToSections(filter: IDoFilter, uiState: IUiStateDoFilters): void {
  const optionKeys = new Set<string>(filter.options.map(option => option.key));
  const hasSavedState = filter.options.some(option => option.key in uiState);

  getSectionRows(filter).forEach(row => {
    if (!optionKeys.has(row.key)) return;

    row.checked = hasSavedState ? getUiStateBoolean(uiState, row.key as DoFilterOptionKey) : true;
  });

  filter.sections?.flat().forEach(item => {
    if (item.children?.length) item.checked = item.children.every(child => child.checked);
  });

  syncSelectedFromSections(filter);
}

export function getUiStateBoolean(uiState: IUiStateDoFilters, key: DoFilterKey | DoFilterOptionKey): boolean {
  return !!(uiState as Record<DoFilterKey | DoFilterOptionKey, boolean | undefined>)[key];
}
